import { render, staticRenderFns } from "./PackageGas.vue?vue&type=template&id=1037ae12"
import script from "./PackageGas.vue?vue&type=script&lang=ts"
export * from "./PackageGas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports